import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

registerCardTemplate({
    id: 'progress-bar-percentage-widget',
    name: 'Progress Bar Percentage Widget',
    description: 'This widget can be used to represent a progress bar and labels using two values. Like current people count with total seat count .',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-progress-bar-percentage-widget" */ "./ProgressBarPercentageWidgetTemplate")),
    icon: generateIconProp('tachometerAlt'),
    complexity: 'easy',
    expectedSchema: 'dictionary',
});
